import { render, staticRenderFns } from "./Magnetism.vue?vue&type=template&id=5919eee6"
import script from "./Magnetism.vue?vue&type=script&lang=js"
export * from "./Magnetism.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports